import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Card11, Card12, Card13 } from './cards';
import { getRoute, PATH } from '@/utils/routes';
import { showViewMoreBtn } from '@/utils/showViewMoreBtn';
import { getPaddingTopValue } from '@/utils/getPaddingTopValue';
import { IS_SERVER } from '@/utils/checkRenderEnv';
import { useSSRSelector } from '@/redux/ssrStore';

const CategoryWidget = (props) => {
  const router = useRouter();
  const [widgetConfig, setWidgetConfig] = useState(null);

  const { catalogCategories, storeData } = useSSRSelector((state) => ({
    catalogCategories: state.catalogReducer.categories,
    storeData: state.storeReducer.store,
  }));

  useEffect(() => {
    if (props.config) {
      setWidgetConfig(props.config);
    }
  }, []);

  useEffect(() => {
    const element = document.getElementById(`scroll-wrapper-${props?.cardType || 0}`);
    const arrowEle = document.getElementsByClassName('arrow-btns');

    const eleChildren = Array.from(element.children);
    let totalWidth = 0;

    for (let i = 0; i < eleChildren.length; i++) {
      totalWidth += eleChildren[i].offsetWidth;
    }

    if (element.offsetWidth > totalWidth) {
      Array.from(arrowEle).map((arrow) => arrow.classList.add('dn'));
    }
  }, [catalogCategories]);

  /**
   * Category widget 14 and 16 are to be fixed to top of screen just below the header.
   * useEffect here finds and calculates the offsetHeight of widget.
   * the calculated offsetHeight it used to push down the parent page body,
   * to offset the layout change that comes from using position: fixed
   * on sibling elements.
   * This feature is only for /shop page
   * @returns {*} void
   */
  useEffect(() => {
    if (
      !IS_SERVER &&
      props?.headerFixedToTop &&
      catalogCategories?.length &&
      router.pathname.includes('/shop')
    ) {
      const horizontalWidget = document.querySelector('.horizontal-CategoryWidget2');
      if (horizontalWidget) {
        horizontalWidget.querySelector('p').style.paddingTop = '35px';
        horizontalWidget.querySelector('p').style.marginTop = '0px';
        const offsettop = getPaddingTopValue(storeData?.theme?.components?.Header);
        horizontalWidget.style.zIndex = 50;
        horizontalWidget.style.top = `${offsettop - 3}px`;
      }
    }
  }, [IS_SERVER, props?.headerFixedToTop, catalogCategories?.length]);

  const onCategoryItemClick = (category) => {
    window.location.href = getRoute(
      `${PATH.SHOP}?cid=${category.id}`,
      storeData?.store_info?.domain
    );
  };

  const onViewMoreCtaClick = () => {
    router.push(getRoute(`${PATH.CATEGORIES}`, storeData?.store_info?.domain));
  };

  const _renderCategoryCard = (category, idx, cardNumer) => {
    switch (cardNumer) {
      case 1:
        return (
          <Card11
            category={category}
            cardIndx={idx}
            widgetConfig={widgetConfig}
            onClick={onCategoryItemClick}
            horizontal={true}
          />
        );
      case 2:
        return (
          <Card12
            category={category}
            cardIndx={idx}
            widgetConfig={widgetConfig}
            onClick={onCategoryItemClick}
            horizontal={true}
          />
        );
      case 3:
        return (
          <Card13
            category={category}
            cardIndx={idx}
            widgetConfig={widgetConfig}
            onClick={onCategoryItemClick}
            horizontal={true}
          />
        );
      default:
        return (
          <Card11
            category={category}
            key={idx}
            widgetConfig={widgetConfig}
            onClick={onCategoryItemClick}
          />
        );
    }
  };

  const scrollNewReleaseSection = (scrollType, SRType) => {
    const scrollMovPos = 330;
    const element = document.getElementById(`scroll-wrapper-${SRType}`);
    const leftArrowEle = document.getElementsByClassName(`modal-left-arrow-${SRType}`);
    const rightArrowEle = document.getElementsByClassName(`modal-right-arrow-${SRType}`);
    let scrollPos = 0;
    if (element) {
      scrollPos = element.scrollLeft;
      if (scrollType === 'left') {
        if (scrollPos < 130) scrollPos = 0;
        else scrollPos -= scrollMovPos;
      } else {
        scrollPos += scrollMovPos;
      }
      if (scrollPos >= 0) {
        element.scrollLeft = scrollPos;
        if (leftArrowEle) {
          !scrollPos
            ? leftArrowEle[0].classList.add('dn')
            : leftArrowEle[0].classList.remove('dn');
        }
        if (rightArrowEle) {
          if (scrollPos + element.offsetWidth >= element.scrollWidth) {
            rightArrowEle[0].classList.add('dn');
          } else {
            rightArrowEle[0].classList.remove('dn');
          }
        }
      }
    }
  };

  /**
   * return categories array. if max_limit exist in config, limit array size to max_limit.
   * @return {*} array
   */
  const getCategoriesList = () => {
    let arr = [];
    if (catalogCategories.length > 0)
      if (widgetConfig?.max_limit) {
        arr = catalogCategories?.slice(0, widgetConfig?.max_limit);
      } else {
        return catalogCategories;
      }
    return arr;
  };

  return (
    /**
     * props.headerFixedToTop is used to set custom classes to the horizontal widgetz.
     * only in case of categoryWidget 14 and 16
     * @return {*} void
     */
    <div className="horizontal-CategoryWidget2 top-0 left-0 w-100 bg-white">
      <h1 className="tl title fw6 ph3 ph4-ns tc">
        {widgetConfig?.heading || 'View More Categories'}
      </h1>
      <div className="relative">
        {catalogCategories?.length > 1 && !props.noArrows && (
          <>
            <img
              alt="Left Button"
              src="/assets/icons/arrowLeftIconCircleDark.png"
              className={`modal-left-arrow-${
                props?.cardType || 0
              } arrow-btns absolute left-1-ns left-0 img pointer dn`}
              onClick={() => scrollNewReleaseSection('left', props?.cardType || 0)}
            ></img>
            <img
              alt="Right Button"
              src="/assets/icons/arrowRightIconCircleDark.png"
              className={`modal-right-arrow-${
                props?.cardType || 0
              } arrow-btns absolute right-1-ns right-0 img pointer`}
              onClick={() => scrollNewReleaseSection('right', props?.cardType || 0)}
            ></img>
          </>
        )}
        <section
          className={`scroll-wrapper ${props.customScrollClass ? 'custom-scroll' : ''}`}
          id={`scroll-wrapper-${props?.cardType || 0}`}
        >
          <div className="ml1 ml5-ns ph2 ph5-ns"></div>
          {getCategoriesList()?.length > 0 &&
            getCategoriesList().map((category, index) =>
              _renderCategoryCard(category, index, props.cardType)
            )}
          {showViewMoreBtn(widgetConfig?.max_limit, catalogCategories) && (
            <article
              className="category-card pointer flex items-start view-more-box"
              onClick={onViewMoreCtaClick}
            >
              <div
                className="view-more-box--inner relative"
                style={{
                  paddingTop: `${
                    widgetConfig?.aspect_ratio ||
                    10000 / storeData?.theme?.product_aspect_ratio ||
                    100
                  }%`,
                }}
              >
                <span>
                  View More
                  <span />
                </span>
              </div>
            </article>
          )}
          <div className="ml1 ml5-ns ph2 ph5-ns"></div>
        </section>
      </div>
    </div>
  );
};

export default CategoryWidget;
